import { createApp } from 'vue'
import store from './store'
import App from './App.vue'
import router from './routes/index'
import { updatePageMeta } from '@/utils/domainConfig'

import './assets/main.css'

// 根据域名更新页面标题和favicon
updatePageMeta()

createApp(App).use(router).use(store).mount('#app')